import React, { useCallback, useState } from "react";
import { useNavigationContext, usePolling } from "go-core/hooks";

interface PollingAlertProps {
	pollingFunction: () => Promise<boolean> | boolean;
	pollingInterval: number;
	children: React.ReactNode;
}

export const PollingAlert = ({ pollingFunction, pollingInterval, children }: PollingAlertProps) => {
	const { isNavigationCollapsed } = useNavigationContext();
	const [shouldShowAlert, setShouldShowAlert] = useState(false);
	const onPoll = useCallback(async () => setShouldShowAlert(await pollingFunction()), [pollingFunction]);

	usePolling(onPoll, pollingInterval);

	if (!shouldShowAlert) return null;

	return <div className={`polling-alert ${isNavigationCollapsed ? "small" : ""}`}>{children}</div>;
};
